import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Host, MenuItem} from "../../../../common";

/**
 * item card for quick selection / flattened order view
 * ATM this is only used in select-benefit component, but
 * we might have a flat list later.
 */
@Component({
  selector: 'option-list',
  standalone: false,
  template: `
    <div *ngIf="item.hasOptions()" class="mt-3">
      <h6 i18n>Options</h6>
      <div class="form-check" *ngFor="let option of item.getOptions().slice(0, (expanded)?999:3); let i=index;">
        <input [(ngModel)]="selections[option.id]" class="form-check-input hide-validation-status" type="checkbox"
               name="option" id="o_{{ option.id }}" value="{{ option.id }}">
        <label class="form-check-label row" for="o_{{ option.id }}">
          <div class="col">{{ option.name }} <span *ngIf="option.price > 0">(+ {{ option.price|currency:host }})</span></div>
        </label>
      </div>
      <div *ngIf="!expanded && item.getOptions().length > 3"><a href="" (click)="toggleExpand()" i18n>Show {{item.getOptions().length-3}} more...</a></div>
      <div *ngIf="expanded"><a href="" (click)="toggleExpand()" i18n>Show less</a></div>
    </div>
  `
})
export class OptionList {
  @Input() item: MenuItem;
  @Input() host: Host;
  @Input() selections: any;

  expanded: boolean = false;

  toggleExpand() {
    this.expanded = !this.expanded;
    return false;
  }

}

